const config = {
    LINNIA_IPFS_HOST: 'ipfs.infura.io',
    LINNIA_IPFS_PORT: '5001',
    LINNIA_IPFS_PROTOCOL: 'https',
    LINNIA_HUB_ADDRESS: '0x177bf15e7e703f4980b7ef75a58dc4198f0f1172',
    LINNIA_SEARCH_URI: 'http://18.222.147.7:3000',
    //CONTRACT_OWNER_PK: '0x30e98e77b2d90175163b14bd2c902061350f58b4',  // Amit
    CONTRACT_OWNER_PK: '0x8B8ba03Ed61Ad1CB0E9bEFD0D02ECB444834887D',   // Vutsal
};

export default config;


// WEBPACK FOOTER //
// ./src/config.js